import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { DEFAULT_PAGE_SIZE } from 'constants/catalog';
import { PagedResult } from 'types/api';
import { ProductSummary } from 'types/product';
import { asProductList, mapStoreProduct, StoreProductApiItem } from 'utils/mapStoreProduct';

const searchService = {
  search: async (q: string, pageNumber = 1, pageSize = DEFAULT_PAGE_SIZE): Promise<PagedResult<ProductSummary>> => {
    const response = await api.get<PagedResult<StoreProductApiItem>>(ENDPOINTS.SEARCH, {
      params: { q, pageNumber, pageSize },
    });
    const data = response.data;
    return {
      ...data,
      items: asProductList(data).map(mapStoreProduct),
    };
  },
};

export default searchService;
